import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from '../../../adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from '../../../adapters/types'
import { DischargeFormData } from '../../types/formData'
import { DischargeFormField } from '../../types/formField'
import { DischargeAssessmentQuestionnaireItem } from '../../types/questionnaire'
import { getAppointmentTimeWithTimezone } from '../../../helpers'
import { convertAppointmentTimeFormDataToFlatAnswers } from '../../../helpers.uncontrolled'

/**
 * Assessment Overview subsection adapter
 * Handles appointment time extraction and transformation
 */
export class AssessmentOverviewAdapter extends BaseSubsectionAdapter<DischargeFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options?: AdapterOptions
  ): Partial<DischargeFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Extract appointment time with timezone support
    const appointmentTime = getAppointmentTimeWithTimezone(
      flatAnswersArray,
      options?.caregiverTimezone
    )

    return {
      [DischargeFormField.APPOINTMENT_TIME]: appointmentTime
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(DischargeFormField.APPOINTMENT_TIME)) {
      const appointmentTimeField = this.getFormDataField(DischargeFormField.APPOINTMENT_TIME)
      const { appointmentTimeValues } = convertAppointmentTimeFormDataToFlatAnswers(
        Array.isArray(appointmentTimeField) ? appointmentTimeField : [undefined, undefined]
      )

      mutations.push({
        linkId: DischargeAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_START,
        value: appointmentTimeValues?.at(0)
      })
      mutations.push({
        linkId: DischargeAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_END,
        value: appointmentTimeValues?.at(1)
      })
    }

    return mutations
  }
}
